var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSizem2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.916 17H1.224V8.198H2.736L2.898 9.35C3.348 8.522 4.284 7.946 5.526 7.946C6.894 7.946 7.866 8.63 8.316 9.728C8.73 8.63 9.792 7.946 11.16 7.946C13.176 7.946 14.4 9.206 14.4 11.24V17H12.744V11.654C12.744 10.268 11.97 9.476 10.782 9.476C9.504 9.476 8.658 10.376 8.658 11.78V17H6.984V11.636C6.984 10.25 6.228 9.494 5.04 9.494C3.762 9.494 2.916 10.376 2.916 11.78V17Z",
    fill: "#0A0A0A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.272 9.992L16.368 10V9.4L18.232 7.792C19.168 6.984 19.432 6.592 19.432 5.976C19.432 5.248 19.016 4.816 18.32 4.816C17.608 4.816 17.144 5.336 17.128 6.16H16.344C16.368 4.92 17.152 4.112 18.328 4.112C19.488 4.112 20.232 4.816 20.232 5.928C20.232 6.752 19.824 7.336 18.8 8.224L17.6 9.264H20.272V9.992Z",
    fill: "#0A0A0A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSizem2);
export default __webpack_public_path__ + "static/media/sizem2.32e3d6dac5b1b9664ac32efd5ef040d4.svg";
export { ForwardRef as ReactComponent };